module.exports = __webpack_public_path__ + "media/icons/graph-icon-632482cf.png";